<template>
  <div class="trainee-list-modal-overlay">
    <transition name="modal-expand">
    <div v-if="isVisible" class="trainee-list-modal" @click.stop>
      <div class="modal-content">          
        <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
        <h2>Edit Logbook ID: {{ newLogbook.logbook_id }}</h2>

        <div class="add">
          <form @submit.prevent="updateLogbook">
            <div class="form-group">
              <label for="name">Name:</label>
              <input type="text" class="form-control rounded" id="logbook_name" name="logbook_name" placeholder="Enter Logbook Name"
                v-model="newLogbook.name" />
            </div>
            <div v-if="showAlert" class="alert alert-danger error-message" role="alert">
              <div v-if="errorMessage">{{ errorMessage }}</div>
            </div>
            <div>
              <button class="btn btn-primary rounded" type="submit" style="margin-top: 0px;">Update Logbook</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    </transition>
  </div>
</template>
  
<script>

import axios from 'axios';

export default {
  props: {
    logbook: { type: Object, default: null },
  },
  data() {
    return {
      newLogbook: {
        name: '',
      },
      showAlert: false,
      errorMessage: '',
      isVisible: false,
    };
  },
  methods: {
    async updateLogbook() {
      try {
        const logbook_id = this.logbook.logbook_id;
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        const response = await axios.put(
          `/api/logbooks/${logbook_id}`,
          {
            name: this.newLogbook.name,
          },
          { headers }
        );

        console.log('update')
        console.log(response);

        if (response.status === 200) {
          window.alert('Logbook updated Successfully');
          this.$emit('updated', {
            ...this.logbook,
            name: this.newLogbook.name,
          });
          this.errorMessage = '';
          this.showAlert = false;
          this.close();
        }

      } catch (error) {
        console.error('Error adding User:', error.response);

        if (error.response && error.response.data && error.response.data.errors) {
          // Handle validation errors
          const validationErrors = error.response.data.errors;

          // Build an error message from the validation errors
          let errorMessage = 'Validation errors:';
          for (const field in validationErrors) {
            errorMessage += `\n${field}: ${validationErrors[field][0]}`;
          }

          this.errorMessage = errorMessage;
        } else {
          // Handle other errors
          this.errorMessage = 'An error occurred while updating the logbook.';
        }

        this.showAlert = true;
      }
    },
    close() {
      this.$emit('close'); // Emit an event to indicate the modal should be closed
    },
  },
  async mounted() {
    this.isVisible = true;
    this.newLogbook.name = this.logbook.name;
    this.newLogbook.logbook_id = this.logbook.logbook_id;
  },
}
</script>
  
<style scoped>
.trainee-list-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  /* Ensure the modal is on top of other content */
}

h2 {
  margin-top: 10px;
  font-size: 30px;
  margin-bottom: 30px;
}

/* Style your modal content */
.trainee-list-modal {
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  width: 80%;
  max-width: 1000px;
  /* Limit the maximum width of the modal */
  padding: 20px;
  position: relative;
  max-height: 95%;

}


.modal-content {
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
  padding: 15px;
  border: 1px solid #dddddd;
  border-radius: 3px;
}

.add button {
  width: 200px;
  height: 40px;
  margin-bottom: 20px;
  border: 1px solid rgb(0, 96, 134);
  background: #2952c4;
  color: white;
  cursor: pointer;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
}

button.btn:hover {
  background-color: #0c1a61;
  transition: transform 0.2s, box-shadow 0.2s;
}

input.form-control {
  width: 70%;
  margin-left: 100px;
  display: inline-block;
  margin-bottom: 25px;
  height: 40px;
  align-items: baseline;
  border: 1px solid #ccc;
}

.form-group {
  margin-bottom: 15px;
}

label {
  margin-right: 5px;
  position: absolute;
  margin-top: 8px;
}

.form-control {
  border-radius: 5px;
}

.alert-danger {
    color: #ff0019;
    background-color: #f8d7da;
    border: 1px solid #e6b0b6;
}

.alert {
    position: relative;
    padding: .75rem 1.25rem;
    margin-bottom: 0rem;
    border: 1px solid transparent;
    border-radius: .25rem;
}
</style>
  